import axios from 'axios';

const BASE_URL = process.env.REACT_APP_BACKEND_URL_API;

const axiosInstance =  axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});

axiosInstance.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    if (error.response.status === 401) {
      localStorage.setItem('user', '');
      localStorage.setItem('roles', JSON.stringify([]));
      window.location.href = '/login';
    } else {
      return Promise.reject(error);
    }
  },
);

export default axiosInstance;